import React, { useCallback, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import { useDebounce } from 'use-debounce'
import { message, Select, Button as AntButton } from 'antd'
import api from '../../../../api'
import ErrorModal from '../../ErrorModal'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		width: 'min(520px, 92vw)',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 16,
		border: 'none',
		padding: 24,
	},
	overlay: { background: '#00000099', zIndex: 50 },
}

const CreateBlackListUser = ({ isOpen, onClose, onSuccess }) => {
	const errorModalRef = useRef()
	const [searchValue, setSearchValue] = useState('')
	const [debouncedSearch] = useDebounce(searchValue, 500)
	const [clients, setClients] = useState([])
	const [selected, setSelected] = useState(null)
	const [selectedClient, setSelectedClient] = useState(null)
	const [isSearching, setIsSearching] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	const getClients = useCallback(async (client) => {
		const q = (client || '').replace(/'/g, "''")
		setIsSearching(true)
		try {
			const res = await api.get('BusinessPartners', {
				params: {
					$select: 'CardName, CardCode, U_Telephone, U_PS, Address',
					$filter: `(contains(CardName, '${q}') or contains(U_Telephone, '${q}') or contains(CardCode, '${q}')) and (U_BpComment ne 'Black_List' or U_BpComment eq null)`,
				},
				headers: { Prefer: 'odata.maxpagesize=20' },
			})
			setClients(JSON.parse(res.data).value || [])
		} catch (err) {
			errorModalRef.current?.open(get(err, 'message', ''))
		} finally {
			setIsSearching(false)
		}
	}, [])

	useEffect(() => {
		getClients(debouncedSearch)
	}, [debouncedSearch, getClients])

	const handleBlock = () => {
		setIsLoading(true)
		api
			.patch(`BusinessPartners('${selected}')`, { U_BpComment: 'Black_List' })
			.then(() => {
				message.success('Клиент добавлен в черный список')
				onSuccess?.()
				onClose()
			})
			.catch((err) => {
				let msg = get(err, 'message', '')
				try {
					msg = JSON.parse(err.response.data).error.message
				} catch (e) {}
				errorModalRef.current?.open(msg)
			})
			.finally(() => setIsLoading(false))
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Add Black List Client Modal"
			ariaHideApp={false}
			shouldFocusAfterRender={false}
		>
			<div className="flex flex-col gap-5">
				<p className="text-xl text-center font-bold text-blue-900">
					Добавить в черный список
				</p>
				<Select
					showSearch
					allowClear
					size="large"
					className="w-full"
					placeholder="Выберите клиента"
					filterOption={false}
					value={selected}
					onChange={(code) => {
						setSelected(code)
						setSelectedClient(clients.find((c) => c.CardCode === code) || null)
					}}
					onSearch={setSearchValue}
					loading={isSearching}
					notFoundContent={isSearching ? 'Загрузка...' : 'Не найдено'}
					options={clients.map((c) => ({
						value: c.CardCode,
						label: `${get(c, 'CardName', '-')} · ${get(c, 'CardCode', '')}${
							c.U_Telephone ? ` · ${c.U_Telephone}` : ''
						}`,
					}))}
				/>
				{selectedClient && (
					<div className="grid grid-cols-2 gap-x-4 gap-y-3 p-4 bg-gray-50 rounded-lg border border-[#DFE2E9]">
						{[
							['Код клиента', 'CardCode'],
							['Имя Клиента', 'CardName'],
							['Телефон', 'U_Telephone'],
							['Паспорт', 'U_PS'],
							['Адрес', 'Address'],
						].map(([label, key]) => (
							<div key={key} className={key === 'Address' ? 'col-span-2' : ''}>
								<p className="text-xs text-gray-500 uppercase">{label}</p>
								<p className="text-sm font-medium text-gray-900 break-words">
									{get(selectedClient, key) || '-'}
								</p>
							</div>
						))}
					</div>
				)}
				<div className="flex justify-end gap-3">
					<AntButton size="large" onClick={onClose}>
						Отмена
					</AntButton>
					<AntButton
						size="large"
						type="primary"
						danger
						loading={isLoading}
						disabled={!selected}
						onClick={handleBlock}
					>
						Заблокировать
					</AntButton>
				</div>
			</div>
			<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
		</Modal>
	)
}

export default CreateBlackListUser
